import { serviceMaker } from "..";
import { IPagination } from "../../data/AppInterface";
import { IFirmSubscriptionAssignmentForm } from "../../screens/firm-purchased-subscription/FirmSubscriptionAssignmentFormController";
import { IFirmPurchasedSubscriptionSearch } from "../../screens/firm-purchased-subscription/FirmPurchasedSubscriptionViewController";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";

export const GET_ALL_FIRM_PURCHASED_SUBSCRIPTION = (
  pagination: IPagination,
  search: string,
  advanceSearch: IFirmPurchasedSubscriptionSearch
) =>
  serviceMaker(
    API_ENDPOINTS.get_all_firm_purchased_subscription.url +
      `?perPageRows=${pagination.perPageRows}&currentPage=${
        pagination.currentPage
      }&sortBy=${pagination.sortBy}&orderBy=${pagination.orderBy}${
        search.length > 0 ? `&search=${encodeURIComponent(search)}` : ""
      }${
        advanceSearch.firmId ? `&firm_id=${advanceSearch.firmId}` : ""
      }&showHistoricalRecords=${advanceSearch.showHistoricalRecords}${
        advanceSearch.year ? `&year=${advanceSearch.year}` : ""
      }`,
    API_ENDPOINTS.get_all_firm_purchased_subscription.method
  );

export const GET_FIRM_SUBSCRIPTION_DETAIL = (firmId: string) =>
  serviceMaker(
    API_ENDPOINTS.get_firm_subscription_detail.url + `/${firmId}`,
    API_ENDPOINTS.get_firm_subscription_detail.method
  );

export const GET_ASSIGNABLE_SUBSCRIPTION_PACKAGE = () =>
  serviceMaker(
    API_ENDPOINTS.get_assignable_subscription_package.url,
    API_ENDPOINTS.get_assignable_subscription_package.method
  );

export const ASSIGN_SUBSCRIPTION = (payload: IFirmSubscriptionAssignmentForm) =>
  serviceMaker(
    API_ENDPOINTS.assign_subscription.url,
    API_ENDPOINTS.assign_subscription.method,
    payload
  );

export const CANCEL_SUBSCRIPTION = (id: string) =>
  serviceMaker(
    API_ENDPOINTS.cancel_subscription.url + `/${id}`,
    API_ENDPOINTS.cancel_subscription.method
  );
